var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard"},_vm._l((_vm.keys),function(key){return _c('button',{key:key.direction,class:[
      'keyboard__control',
      ("keyboard__control_" + (key.direction)),
      { keyboard__control_active: _vm.activeKey === key.direction } ],on:{"click":function($event){return _vm.handleKey(key.direction, 'inner')}}},[_vm._v(" "+_vm._s(key.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }